import { useState } from 'react';
import { IBasicOrderInfo } from '../Types';

type UseExtraDeliveryRecipientsDraftResult = {
    extraDeliveryRecipients: string;
    onExtraDeliveryRecipientsChanged: (event: any) => void;
    markExtraDeliveryRecipientsSaved: () => void;
};

export function useExtraDeliveryRecipientsDraft(
    order: IBasicOrderInfo
): UseExtraDeliveryRecipientsDraftResult {
    const [draft, setDraft] = useState('');
    const [hasChanged, setHasChanged] = useState(false);

    if (!hasChanged && order && draft !== order.extraDeliveryRecipients) {
        setDraft(order.extraDeliveryRecipients);
    }

    const onExtraDeliveryRecipientsChanged = (event: any): void => {
        setDraft(event.target.value);
        setHasChanged(true);
    };

    const markExtraDeliveryRecipientsSaved = (): void => {
        setHasChanged(false);
    };

    return {
        extraDeliveryRecipients: draft,
        onExtraDeliveryRecipientsChanged,
        markExtraDeliveryRecipientsSaved
    };
}
